import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import EventsHero from '@/app/events/components/EventsHero';
import EventsGrid from '@/app/events/components/EventsGrid';
import PageTransition from '@/components/PageTransition';

export default function EventsPage() {
  return (
    <main className="min-h-screen bg-background">
      <Header />
      <PageTransition>
        <EventsHero />
        <EventsGrid />
        <Footer />
      </PageTransition>
    </main>
  );
}
